const Pagination = {
	name: "Pagination",
	props: {
		limit: Number,
		offset: Number,
		totalCount: Number,
	},
	computed: {
		summary() {
			return this.totalCount + " " + this.$gettext('záznamů')
		},
		pageCount() {
			let pageCount = 0
			if (this.totalCount) {
				pageCount = Math.ceil(this.totalCount / this.limit)
			}
			return pageCount
		},
		currentPage() {
			let currentPage = 1
			if (this.offset === this.limit) {
				currentPage = 2
			} else {
				currentPage = (this.offset / this.limit) + 1
			}
			return currentPage
		},
	},
	methods: {
		changePage(event, page) {
			event.stopPropagation()
			event.preventDefault()
			this.$emit('offset', this.limit * (page - 1))
		},
	},
	render(createElement) {
		const self = this

		const addItem = (createElement, list, classes, p, showNumber = true) => {
			list.push(createElement('li', [createElement('a', {
				class: classes,
				attrs: {href: '#'},
				on: {
					click(event) {
						self.changePage(event, p)
					}
				}
			}, showNumber ? p : null)]))
		}

		let listItems = []
		let pageCutLow = self.currentPage - 1
		let pageCutHigh = self.currentPage + 1

		if (self.currentPage > 1) {
			addItem(createElement, listItems, 'pagination_prev', self.currentPage - 1, false)
		}

		if (self.pageCount < 6) {
			if (self.pageCount > 1) {
				for (let p = 1; p <= self.pageCount; p++) {
					addItem(createElement, listItems, {active: self.currentPage === p}, p)
				}
			}
		} else {
			if (self.currentPage > 2) {
				addItem(createElement, listItems, {}, 1)
				if (self.currentPage > 3) {
					listItems.push(createElement('li', [createElement('span', '...')]))
				}
			}

			if (self.currentPage === 1) {
				pageCutHigh += 2
			} else if (self.currentPage === 2) {
				pageCutHigh += 1
			}

			if (self.currentPage === self.pageCount) {
				pageCutLow -= 2
			} else if (self.currentPage === self.pageCount - 1) {
				pageCutLow -= 1
			}

			for (let p = pageCutLow; p <= pageCutHigh; p++) {
				if (p === 0) {
					p += 1
				}
				if (p > self.pageCount) {
					continue
				}
				addItem(createElement, listItems, {active: self.currentPage === p}, p)
			}

			if (self.currentPage < self.pageCount - 1) {
				if (self.currentPage < self.pageCount - 2) {
					listItems.push(createElement('li', [createElement('span', '...')]))
				}
				addItem(createElement, listItems, {}, self.pageCount)
			}

			if (self.currentPage < self.pageCount) {
				addItem(createElement, listItems, 'pagination_next', self.currentPage + 1, false)
			}
		}

		const limitOptions = [
			createElement('option', {attrs: {value: 10}}, 10),
			createElement('option', {attrs: {value: 20}}, 20),
			createElement('option', {attrs: {value: 50}}, 50),
			createElement('option', {attrs: {value: 100}}, 100),
			createElement('option', {attrs: {value: 200}}, 200),
			createElement('option', {attrs: {value: 500}}, 500)
		]
		const limitSelect = createElement('select', {
			domProps: {
				value: self.limit
			},
			on: {
				input: function (event) {
					self.$emit('limit', Number(event.target.value))
				}
			}
		}, limitOptions)

		return createElement(
			'div', {class: ['pagination']}, [
				createElement('p', {class: 'per_page'}, [limitSelect]),
				createElement('span', {class: ['summary']}, self.totalCount + " " + this.$gettext('záznamů')),
				createElement('ul', listItems)
			]
		)
	}
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/common/Pagination.js